import { gatewayOpenAiBaseUrl, gatewayChatCompletionsUrl } from './gatewayUrl';

export type QuickStartLang = 'curl' | 'python' | 'node';
export type CurlShell = 'bash' | 'powershell';

export const API_KEY_ENV = 'LLMR_API_KEY';

export function quickStartApiKeyExportBash(): string {
  return `export ${API_KEY_ENV}=your_api_key_here`;
}

export function quickStartApiKeyExportPowerShell(): string {
  return `$env:${API_KEY_ENV}="your_api_key_here"`;
}

export function quickStartInstall(lang: QuickStartLang): string | null {
  switch (lang) {
    case 'python':
      return 'pip install openai';
    case 'node':
      return 'npm install openai';
    case 'curl':
      return null;
  }
}

export function quickStartSnippet(modelId: string, lang: QuickStartLang, curlShell: CurlShell = 'bash'): string | null {
  const chatUrl = gatewayChatCompletionsUrl();
  const openAiBase = gatewayOpenAiBaseUrl();
  if (!chatUrl || !openAiBase) return null;
  return buildQuickStartSnippet({ modelId, lang, chatUrl, openAiBase, curlShell });
}

function chatBodyJson(modelId: string): string {
  return JSON.stringify({
    model: modelId,
    messages: [{ role: 'user', content: 'Hello!' }],
  });
}

export function buildQuickStartSnippet({
  modelId,
  lang,
  chatUrl,
  openAiBase,
  curlShell = 'bash',
}: {
  modelId: string;
  lang: QuickStartLang;
  chatUrl: string;
  openAiBase: string;
  curlShell?: CurlShell;
}): string {
  const modelJson = JSON.stringify(modelId);
  const body = chatBodyJson(modelId);
  switch (lang) {
    case 'curl':
      if (curlShell === 'powershell') {
        const psBody = body.replace(/'/g, "''");
        return [
          `curl.exe -X POST ${JSON.stringify(chatUrl)} \``,
          `  -H "Content-Type: application/json" \``,
          `  -H "Authorization: Bearer $env:${API_KEY_ENV}" \``,
          `  -d '${psBody}'`,
        ].join('\n');
      }
      return `curl -X POST ${JSON.stringify(chatUrl)} \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer $${API_KEY_ENV}" \\
  -d '${body}'`;
    case 'python':
      return `import os
from openai import OpenAI

client = OpenAI(
    base_url=${JSON.stringify(openAiBase)},
    api_key=os.environ["${API_KEY_ENV}"],
)

response = client.chat.completions.create(
    model=${modelJson},
    messages=[{"role": "user", "content": "Hello!"}],
)
print(response.choices[0].message.content)`;
    case 'node':
      return `import OpenAI from "openai";

const client = new OpenAI({
  baseURL: ${JSON.stringify(openAiBase)},
  apiKey: process.env.${API_KEY_ENV},
});

async function main() {
  const response = await client.chat.completions.create({
    model: ${modelJson},
    messages: [{ role: "user", content: "Hello!" }],
  });
  console.log(response.choices[0]?.message?.content);
}

main();`;
  }
}
